import { render, staticRenderFns } from "./daraftListReceive.vue?vue&type=template&id=263191b6&scoped=true"
import script from "./daraftListReceive.vue?vue&type=script&lang=js"
export * from "./daraftListReceive.vue?vue&type=script&lang=js"
import style0 from "./daraftListReceive.vue?vue&type=style&index=0&id=263191b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "263191b6",
  null
  
)

export default component.exports